import { handleRequest } from "../../axios";
import { axiosInstance } from "./JsdhNotifikaceService";
import {
    DEVICE_METRICS_BY_HOSTNAME_URL,
    DEVICE_METRICS_OVERVIEW_URL,
    ADMIN_DEVICE_METRICS_URL,
} from "../url";
import type { DeviceMetricsResponse } from "../generated/models/DeviceMetrics";

/**
 * Get metrics history for a specific device by hostname.
 */
const getMetricsByHostname = (hostname: string, limit = 100) => {
    return handleRequest<DeviceMetricsResponse[]>(() =>
        axiosInstance.get(DEVICE_METRICS_BY_HOSTNAME_URL(hostname), {
            params: { limit },
        })
    );
};

/**
 * Get metrics history for a specific device by device ID.
 */
const getMetricsByDeviceId = (deviceId: number, limit = 100) => {
    return handleRequest<DeviceMetricsResponse[]>(() =>
        axiosInstance.get(ADMIN_DEVICE_METRICS_URL(deviceId), {
            params: { limit },
        })
    );
};

/**
 * Get latest metrics for all devices (overview/dashboard).
 */
const getMetricsOverview = () => {
    return handleRequest<DeviceMetricsResponse[]>(() =>
        axiosInstance.get(DEVICE_METRICS_OVERVIEW_URL)
    );
};

const DeviceMetricsService = {
    getMetricsByHostname,
    getMetricsByDeviceId,
    getMetricsOverview,
};

export default DeviceMetricsService;
